<script>
  import { onDestroy } from "svelte";
  import { currentRoute } from "./store";
  import router from "../router";
  let component;
  const unsubscribe = currentRoute.subscribe(value => {
    component = router.filter(r => r.path === $currentRoute)[0].component;
  });
  onDestroy(unsubscribe);
</script>

<style>

</style>

<div class="container">
  <svelte:component this={component} />
</div>
